import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiEdit3 } from 'react-icons/fi';
import { useEffect } from 'react';
import MoimDetailCommunityBookListPage from './MoimDetailCommunityBookListPage';
import MoimDetailCommunityFreeboardPage from './MoimDetailCommunityFreeboardPage';
import BookListRegisterPage from './BookListRegisterPage';
import { FaTimes } from 'react-icons/fa';
import { useUserInfoQuery, getAccessToken } from '../react-queries/queries';
import { getBookcommunity } from '../api/BookcommunityApi';
import { processApiResponse } from '../common/errorMessage';
import MoimDetailCommunityFreeboardEditPage from './MoimDetailCommunityFreeboardEditPage';



const Wrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  background: #fff;
  min-height: 100vh;
`;

const Content = styled.div`
  padding: 0 0 50px 0;
`;


// 커뮤니티 탭용 스타일
const CommunityContent = styled.div`
  padding: 20px 0 20px 0;
`;


const WriteButton = styled.button`
  background: none;
  border: none;
  color: #888;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;

// 커뮤니티 서브 탭 스타일
const CommunitySubTabRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 20px;
  padding: 4px 0 12px 0;
`;

const CommunitySubTab = styled.button`
  background: ${props => props.active ? '#333' : '#f5f5f5'};
  color: ${props => props.active ? '#fff' : '#666'};
  border: none;
  border-radius: 20px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
`;

const BoardEditModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const BoardEditModal = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 28px 24px 20px 24px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.18);
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 320px;
`;






const EditButton = styled.button`
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background: #1565c0;
  }
`;

const EditModal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;


const EditModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;

const EditModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const EditCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

const EditModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;




function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function MoimDetailCommunityPage({bookCommunity, bookCommunityId , onModified}) {
  const navigate = useNavigate();
  const query = useQuery();
  const tab = query.get('tab');
  const subtab = query.get('subtab');
  const [communityTab, setCommunityTab] = useState(subtab || 'booklist');
  const [moim, setMoim] = useState(bookCommunity);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showBookEditModal, setShowBookEditModal] = useState(false);
  const [showFreeboardEditModal, setShowFreeboardEditModal] = useState(false);
 // const [isModified, setIsModified] = useState(false);
  const [refreshFlag, setRefreshFlag] = useState(0);
  const [refreshFreeboardFlag, setRefreshFreeboardFlag] = useState(0);
  const {data: userInfo} = useUserInfoQuery();

  useEffect(() => {
    //const prevShowBack = showBack;
    //setShowBack(false);
    //setLogoText('');
    //return () => setShowBack(prevShowBack);
  }, []);


// API에서 모임 데이터 가져오기
  useEffect(() => {
    if(bookCommunity) {
      setMoim(bookCommunity)
    } else {
      loadMoimData();
    }
  }, [bookCommunity, bookCommunityId]);



  const loadMoimData = async () => {
    if (!bookCommunityId) {
      setError('모임 ID가 없습니다.');
      return;
    }

    if(loading) {
      return;
    }
    try {
      
      setLoading(true);
      const { accessToken } = await getAccessToken();
      
      const response = await getBookcommunity(accessToken || '', bookCommunityId);
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        setMoim(processedResponse.data);
      } else {
        setError(processedResponse.errorMessage || '모임 정보를 불러오는데 실패했습니다.');
      }
    } catch (err) {
      console.error('모임 데이터 로드 중 오류:', err);
      setError('모임 정보를 불러오는데 실패했습니다.');
    } finally {
        setLoading(false);
    }
  };


  

  // 글쓰기 핸들러
  const handleWritePost = () => {
    // 글쓰기 페이지로 이동 (실제로는 글쓰기 모달이나 페이지로 이동)
    console.log('글쓰기 버튼 클릭됨');
    if (communityTab === 'booklist') {
      openBookEditModal();
      //navigate('/booklist-register');
    } else {
      openFreeboardEditModal();
    }
  };

  const openBookEditModal = () => {
    setShowBookEditModal(true);
  };

  // 수정 모달 닫기
  const closeBookEditModal = (modified) => {
    setShowBookEditModal(false);
    if(modified) {
      setRefreshFlag(prev=>prev+1); 
    }
  };

  const openFreeboardEditModal = () => {
    setShowFreeboardEditModal(true);
  };

  const closeFreeboardEditModal = (modified) => {
    setShowFreeboardEditModal(false);
    if(modified) {
      setRefreshFreeboardFlag(prev=>prev+1); 
    }
  };

  const isOwner = moim && userInfo && moim.owner.id === userInfo.id;

 

  return (
    <Wrapper>
      <Content>
        {/* 커뮤니티 탭 내용 */}
          <CommunityContent>
            {/* 커뮤니티 서브 탭 */}
            <CommunitySubTabRow>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                <div style={{display: 'flex', gap: '8px', alignItems: 'center'}}>
                  <CommunitySubTab 
                    active={communityTab === 'booklist'} 
                    onClick={() => setCommunityTab('booklist')}
                  >
                    도서 리스트
                  </CommunitySubTab>
                  <CommunitySubTab 
                    active={communityTab === 'freeboard'} 
                    onClick={() => setCommunityTab('freeboard')}
                  >
                    자유게시판
                  </CommunitySubTab>
                </div>
                {(isOwner && communityTab === 'booklist' && (
                  <WriteButton onClick={handleWritePost}>
                  <FiEdit3 size={16} />
                  {'도서등록'}
                </WriteButton>
                )) || (communityTab !== 'booklist' && (
                  <WriteButton onClick={handleWritePost}>
                  <FiEdit3 size={16} />
                  {'글쓰기'}
                </WriteButton>
                ))}
              </div>
            </CommunitySubTabRow>

            {/* 도서 리스트 탭 */}
            {communityTab === 'booklist' && (
             <MoimDetailCommunityBookListPage bookCommunityId={bookCommunityId} refreshFlag={refreshFlag} />
            )}

            {/* 자유게시판 탭 */}
            {communityTab === 'freeboard' && (
              <MoimDetailCommunityFreeboardPage bookCommunityId={bookCommunityId} refreshFlag={refreshFreeboardFlag} />
            )}
          </CommunityContent>
      </Content>
      {/* 수정 모달 */}
      {showBookEditModal && (
        <EditModal>
          <EditModalHeader>
            <EditModalTitle>도서등록</EditModalTitle>
            <EditCloseButton onClick={()=>closeBookEditModal(false)}>
              <FaTimes />
            </EditCloseButton>
          </EditModalHeader>
          <EditModalContent>
            <BookListRegisterPage bookCommunityId={bookCommunityId} editBookId={null} onClose={closeBookEditModal} />
          </EditModalContent>
        </EditModal>
      )}

      {showFreeboardEditModal && (
        <BoardEditModalOverlay>
        <BoardEditModal>
          <EditModalHeader>
            <EditModalTitle>글쓰기</EditModalTitle>
            <EditCloseButton onClick={()=>closeFreeboardEditModal(false)}>
              <FaTimes />
            </EditCloseButton>
          </EditModalHeader>
          <EditModalContent>
            <MoimDetailCommunityFreeboardEditPage bookCommunityId={bookCommunityId} onClose={closeFreeboardEditModal} />
          </EditModalContent>
        </BoardEditModal>
        </BoardEditModalOverlay>
      )}
    </Wrapper>
  );
} 